(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguestatistics/assets/javascripts/views/statleaguestatistics.js') >= 0) return;  svs.modules.push('/components/statistics/leaguestatistics/assets/javascripts/views/statleaguestatistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatLeagueStatistics = svs.statistics.views.StatBase.extend(
    {
      PAGE_SIZE: 10,
      tagName: 'div',
      classId: 'StatLeagueStatistics',
      firstTime: true,
      SPORT_HOCKEY: 'sport-hockey',
      events: {
        'change #underlyingLeaguesFilter': 'selectMenu',
        'change #playerStatsTeamFilter': 'selectMenu',
        'change #playerStatsTypeFilter': 'selectMenu',
        'change #teamStatsTypeFilter': 'selectMenu',
        'change #teamStatsHomeAwayFilter': 'selectMenu',
        'click #playerStatsQuantity': 'moreButton',
        'click #teamStatsQuantity': 'moreButton'
      },
      options: null,
      initialize: function(options) {
        if (!options.params.leagueId) {
          return;
        }
        this.filters = this.createFilters();
        this.resetFilters();
        this.filters.playerStatsQuantity = this.PAGE_SIZE;
        this.filters.teamStatsQuantity = this.PAGE_SIZE;
        this.options = options;

        if (
          this.options.params.league &&
          this.options.params.league instanceof svs.statistics.models.League
        ) {
          this.leaguesModel = this.options.params.league;
          this.setupModel();
        } else {
          this.leaguesModel = new svs.statistics.models.League({
            leagueId: this.options.params.leagueId
          });
          this.leaguesModel.fetch();
          this.leaguesModel.on('change', this.setupModel, this);
        }
      },

      setupModel: function() {
        var league = {};
        if (_.isObject(this.leaguesModel.get('league'))) {
          league = this.leaguesModel.get('league');
        }
        this.model = new svs.statistics.models.StatLeagueStatistics({
          leagueId: this.options.params.leagueId,
          league: league
        });
        this.model.on('change', this.render, this);

        if (
          !!(((svs.statistics || {}).data || {}).leagueModels || {})
            .statistics &&
          !this.findErrors(svs.statistics.data.leagueModels.statistics)
        ) {
        } else {
          this.update(this.options);
        }
      },

      createFilters: function() {
        var filters = {
          playerStatsTeamFilter: {
            filterValues: {
              all: { name: 'Alla lag', selected: false, id: 'all' }
            },
            selectedKey: 'all',
            disableDropDown: true
          },
          playerStatsTypeFilter: {
            filterValues: {},
            selectedKey: ''
          },
          playerStatsQuantity: 0,
          playerStatsMoreExists: true,
          teamStatsHomeAwayFilter: {
            filterValues: {
              total: { name: 'Alla', selected: true },
              home: { name: 'Hemma', selected: false },
              away: { name: 'Borta', selected: false }
            },
            selectedKey: 'total'
          },
          teamStatsTypeFilter: {
            filterValues: {
              numGoalsPerMatchFor: {
                name: 'Offensiv',
                sortMultiplicator: -1,
                selected: true
              },
              numGoalsPerMatchAgainst: {
                name: 'Defensiv',
                sortMultiplicator: 1,
                selected: false
              }
            },
            selectedKey: 'numGoalsPerMatchFor'
          },
          underlyingLeaguesFilter: {
            filterValues: {},
            selectedKey: '',
            showDropDown: false
          },
          teamStatsQuantity: 0,
          teamStatsMoreExists: true
        };
        return filters;
      },

      findErrors: function(data) {
        var foundError = false;
        if (_.isObject(data.response)) {
          foundError = true;
        } else if (data.responses) {
          var responses = data.responses;
          var rsp = null;
          for (var i = 0; i < responses.length; i++) {
            rsp = responses[i];
            if (_.isObject(rsp.error)) {
              foundError = true;
              break;
            }
          }
        }
        return foundError;
      },
      update: function() {
        var _self = this;
        this.model.fetch({
          error: function() {
            _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
            _self.$('.js-statistics-reload').bind('click', function() {
              $(this).unbind('click');
              _self.update();
            });
          }
        });
      },
      render: function() {
        if (!this.model) {
          this.$el.html(
            svs.statistics.statistics.templates.nodata({
              renderEmpty: this.options.params.preDraw
            })
          );
          return this;
        }

        if (
          this.retrieveSportById(this.model.get('league').sport.id) ===
          this.SPORT_HOCKEY
        ) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
          return this;
        }

        this.$el.html(
          svs.statistics.leaguestatistics.templates.statleaguestatistics(
            this.applyFilters()
          )
        );
        if (
          Object.prototype.hasOwnProperty.call(this.options.params, 'parent')
        ) {
          this.options.params.parent.trigger('resize');
        }

        this.hideLoader();
        return this;
      },
      applyFilters: function() {
        var players = [],
          teams = this.model.get('teams');

        this.setupPlayerStatTeamDropDownModule();
        this.setupPlayerStatDropDownModule();
        this.setupLeagueDropDownModule();
        players = this.setupPlayerStatModule(players);
        teams = this.setupOffensiveDefensiveModule(teams);
        return {
          players: players,
          teams: teams,
          filters: this.filters,
          sortedTeams: this.sortedTeamList
        };
      },
      setupPlayerStatTeamDropDownModule: function() {
        var playerStatistics = this.model.get('playerStatistics'),
          self = this;

        if (
          this.firstTime &&
          self.filters.playerStatsTeamFilter.selectedKey !== 'all'
        ) {
          if (!this.teamId) {
            var pos = 0;
            if ((((playerStatistics || {}).byTeam || {})[pos] || {}).id) {
              this.teamId = playerStatistics.byTeam[pos].id;
            }
          }
          self.filters.playerStatsTeamFilter.selectedKey = this.teamId;
        }
        if (
          _.size(this.filters.playerStatsTeamFilter.filterValues) < 2 ||
          (this.sortedTeamList || []).length < 2
        ) {
          this.sortedTeamList = [];
          this.sortedTeamList.push(
            self.filters.playerStatsTeamFilter.filterValues.all
          );

          if ((playerStatistics || {}).byTeam) {
            _.each(playerStatistics.byTeam, function(teamstat) {
              if (self.firstTime && teamstat.id === self.teamId) {
                self.firstTime = false;
                self.filters.playerStatsTeamFilter.filterValues[teamstat.id] = {
                  name: teamstat.mediumName,
                  selected: true,
                  id: teamstat.id
                };
                self.sortedTeamList.push({
                  name: teamstat.mediumName,
                  selected: true,
                  id: teamstat.id
                });
                self.teamName = teamstat.mediumName;
              } else {
                self.filters.playerStatsTeamFilter.filterValues[teamstat.id] = {
                  name: teamstat.mediumName,
                  selected: false,
                  id: teamstat.id
                };
                self.sortedTeamList.push({
                  name: teamstat.mediumName,
                  selected: false,
                  id: teamstat.id
                });
              }
            });
          }
          if (
            this.retrieveSportById(this.model.get('league').sport.id) !==
            this.SPORT_HOCKEY
          ) {
            if (_.size(this.filters.playerStatsTeamFilter.filterValues) > 1) {
              this.filters.playerStatsTeamFilter.disableDropDown = false;
            }
          }
        }
      },
      setupLeagueDropDownModule: function() {
        var underlyingLeagues = null,
          _self = this;

        if (this.model.get('league')) {
          underlyingLeagues = this.model.get('league').underlyingLeagues;
        }
        var isFirst = true,
          keyName;

        if (_.size(this.filters.underlyingLeaguesFilter.filterValues) < 1) {
          isFirst = true;
          _.each(underlyingLeagues, function(league) {
            keyName = 'id_' + league.id;
            _self.filters.underlyingLeaguesFilter.filterValues[keyName] = {
              name: league.name,
              selected: isFirst
            };
            if (isFirst) {
              _self.filters.underlyingLeaguesFilter.selectedKey = keyName;
              isFirst = false;
            } else {
              _self.filters.underlyingLeaguesFilter.showDropDown = true;
            }
          });
        }
      },
      setupPlayerStatDropDownModule: function() {
        var playerStatistics = this.model.get('playerStatistics'),
          self = this,
          keystat = [];

        if (!playerStatistics) return;

        if (_.size(this.filters.playerStatsTypeFilter.filterValues) < 3) {
          if (self.filters.playerStatsTeamFilter.selectedKey === 'all') {
            keystat = playerStatistics.byKey;
            keystat = this.removeEmptyKeys(keystat);
            self.createPlayerStatsDropDownItems(keystat);
          } else {
            if ((playerStatistics || {}).byTeam) {
              _.each(playerStatistics.byTeam, function(teamStat) {
                if (
                  self.filters.playerStatsTeamFilter.selectedKey === teamStat.id
                ) {
                  keystat = teamStat.byKey;
                  self.createPlayerStatsDropDownItems(keystat, teamStat);
                }
              });
            }
          }
        }
      },
      createPlayerStatsDropDownItems: function(keystat, teamStat) {
        var self = this,
          playerStatistics = teamStat
            ? teamStat
            : this.model.get('playerStatistics');

        self.filters.playerStatsTypeFilter.selectedKey = '';
        for (var i in keystat) {
          if (Object.prototype.hasOwnProperty.call(keystat, i)) {
            self.filters.playerStatsTypeFilter.filterValues[i] = {
              key: i,
              name: playerStatistics.keys[i].description
                ? playerStatistics.keys[i].description
                : playerStatistics.keys[i],
              sortMultiplicator: -1,
              selected: false,
              sortIndex: this.findSortOrderByKey(
                playerStatistics.keys[i].description
                  ? playerStatistics.keys[i].description
                  : playerStatistics.keys[i]
              )
            };
          }
        }
        self.filters.playerStatsTypeFilter.filterValues = this.sortStatsTypeFilter(
          self.filters.playerStatsTypeFilter.filterValues
        );
      },
      setupPlayerStatModule: function(players) {
        if (!this.model.get('playerStatistics')) return;

        var self = this;
        var playerStatistics = this.model.get('playerStatistics'),
          byPlayer = playerStatistics.byPlayer,
          filteredPlayersByKeys = [];
        players = playerStatistics.players;

        if (this.filters.playerStatsTeamFilter.selectedKey !== 'all') {
          _.each(playerStatistics.byTeam, function(teamstat) {
            if (
              teamstat.id === self.filters.playerStatsTeamFilter.selectedKey
            ) {
              players = teamstat.players;
              byPlayer = teamstat.byPlayer;

              if (players) {
                filteredPlayersByKeys =
                  teamstat.byKey[
                    self.filters.playerStatsTypeFilter.selectedKey
                  ];
              }
            }
          });
        } else {
          players = playerStatistics.players;
          byPlayer = playerStatistics.byPlayer;
          if (players) {
            filteredPlayersByKeys =
              playerStatistics.byKey[
                self.filters.playerStatsTypeFilter.selectedKey
              ];
          }
        }

        if (!filteredPlayersByKeys) {
          filteredPlayersByKeys = [];
        }
        players = this.findPlayersById(
          filteredPlayersByKeys,
          players,
          byPlayer
        );

        players = _.sortBy(players, function(player) {
          return player.lastName;
        });

        players = _.sortBy(players, function(player) {
          return (
            player.valueText *
            self.filters.playerStatsTypeFilter.filterValues[
              self.filters.playerStatsTypeFilter.selectedKey
            ].sortMultiplicator
          );
        });

        this.filters.playerStatsMoreExists =
          _.size(players) > this.filters.playerStatsQuantity;

        players = _.first(players, this.filters.playerStatsQuantity);

        var position = 1;
        _.each(players, function(player) {
          player.position = position++;
        });

        return players;
      },
      removeEmptyKeys: function(keystat) {
        var oTempKeyList = {};
        for (var i in keystat) {
          if (keystat[i].length > 0) {
            oTempKeyList[i] = keystat[i];
          }
        }
        return oTempKeyList;
      },
      sortStatsTypeFilter: function(playerStatsTypeFilter) {
        var tempFilterList = [],
          i;
        for (i in playerStatsTypeFilter) {
          if (Object.prototype.hasOwnProperty.call(playerStatsTypeFilter, i)) {
            tempFilterList.push(playerStatsTypeFilter[i]);
            playerStatsTypeFilter[i] = null;
            delete playerStatsTypeFilter[i];
          }
        }
        tempFilterList = _.sortBy(tempFilterList, function(tempFilter) {
          return tempFilter.sortIndex;
        });
        tempFilterList = _.filter(tempFilterList, function(tempFilter) {
          return tempFilter.sortIndex >= 0;
        });
        playerStatsTypeFilter = {};

        var foundGoal = false;
        for (i = 0; i < tempFilterList.length; i++) {
          playerStatsTypeFilter[tempFilterList[i].key] = tempFilterList[i];

          if (
            playerStatsTypeFilter[tempFilterList[i].key].name ===
              this.model.GOALS &&
            !foundGoal
          ) {
            foundGoal = true;
            playerStatsTypeFilter[tempFilterList[i].key].selected = true;
            this.filters.playerStatsTypeFilter.selectedKey =
              tempFilterList[i].key;
          }
        }

        if (!foundGoal) {
          for (i in playerStatsTypeFilter) {
            if (
              Object.prototype.hasOwnProperty.call(playerStatsTypeFilter, i)
            ) {
              playerStatsTypeFilter[i].selected = true;
              this.filters.playerStatsTypeFilter.selectedKey =
                playerStatsTypeFilter[i].key;
              break;
            }
          }
        }

        return playerStatsTypeFilter;
      },
      findSortOrderByKey: function(oStatKey) {
        var sortIndex = -1;
        if (oStatKey === this.model.GOALS) sortIndex = 0;
        else if (oStatKey === this.model.ASSISTS) sortIndex = 1;
        else if (oStatKey === this.model.YELLOW_CARDS) sortIndex = 2;
        else if (oStatKey === this.model.TOTAL_RED_CARDS) sortIndex = 3;
        else if (oStatKey === this.model.YELLOW_OR_RED_CARDS) sortIndex = -1;
        else if (oStatKey === this.model.RED_CARDS) sortIndex = -1;
        else if (oStatKey === this.model.MATCHES_PLAYED) sortIndex = 4;
        else if (oStatKey === this.model.SUBSTITUTIONS_IN) sortIndex = 5;
        else if (oStatKey === this.model.SUBSTITUTIONS_OUT) sortIndex = 6;
        else if (oStatKey === this.model.STARTING_XI) sortIndex = 7;
        return sortIndex;
      },
      findPlayersById: function(
        filteredPlayersByKey,
        totalPlayers,
        byPlayerStats
      ) {
        var value = 0,
          playerId = null,
          filteredJoinedPlayersList = [],
          goals = null,
          assists = null;

        for (var i = 0; i < filteredPlayersByKey.length; i++) {
          playerId = filteredPlayersByKey[i].playerId;
          value = filteredPlayersByKey[i].value;

          goals = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'goalsIntournament'
          );
          if (!goals) {
            goals = this.findStatKeysByPlayer(
              byPlayerStats[playerId],
              'goalsForTeam'
            );
          }

          assists = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'assistsInTournament'
          );
          if (!assists) {
            assists = this.findStatKeysByPlayer(
              byPlayerStats[playerId],
              'assistsForTeam'
            );
          }

          for (var t = 0; t < totalPlayers.length; t++) {
            if (totalPlayers[t].id === playerId) {
              filteredJoinedPlayersList.push({
                playerId: playerId,
                valueText: Math.round(parseFloat(value)),
                name: totalPlayers[t].name,
                firstName: totalPlayers[t].firstName,
                lastName: totalPlayers[t].lastName,
                team: { mediumName: 'test' },
                goals: goals ? goals : '0',
                assists: assists ? assists : '0'
              });
            }
          }
        }
        return filteredJoinedPlayersList;
      },
      findStatKeysByPlayer: function(playerData, needle) {
        var statResult = null;
        _.each(playerData, function(data) {
          if (data.key === needle) {
            statResult = data.value;
          }
        });
        return statResult;
      },
      setupOffensiveDefensiveModule: function(teams) {
        var self = this,
          position = 1;

        teams = _.sortBy(teams, function(teamstat) {
          return teamstat.team.name;
        });

        teams = _.sortBy(teams, function(teamstat) {
          return (
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
              self.filters.teamStatsTypeFilter.selectedKey
            ] *
            self.filters.teamStatsTypeFilter.filterValues[
              self.filters.teamStatsTypeFilter.selectedKey
            ].sortMultiplicator
          );
        });

        this.filters.teamStatsMoreExists =
          _.size(teams) > this.filters.teamStatsQuantity;

        teams = _.sortBy(teams, function(teamstat) {
          if (
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
              self.filters.teamStatsTypeFilter.selectedKey
            ] === null
          ) {
            return;
          }
          return (
            parseFloat(
              teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
                self.filters.teamStatsTypeFilter.selectedKey
              ].replace(',', '.')
            ) *
            self.filters.teamStatsTypeFilter.filterValues[
              self.filters.teamStatsTypeFilter.selectedKey
            ].sortMultiplicator
          );
        });

        teams = _.first(teams, this.filters.teamStatsQuantity);

        _.each(teams, function(teamstat) {
          teamstat.valueText =
            teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey][
              self.filters.teamStatsTypeFilter.selectedKey
            ];
          teamstat.valueText = teamstat.valueText
            ? teamstat.valueText.toString().replace('.', ',')
            : '';

          if (
            self.filters.teamStatsTypeFilter.selectedKey ===
            'numGoalsPerMatchFor'
          ) {
            teamstat.labelText =
              teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
                .numGoalsFor +
              ' gjorda mål på ' +
              teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
                .numMatches +
              ' matcher';
          } else {
            teamstat.labelText =
              teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
                .numGoalsAgainst +
              ' insläppta mål på ' +
              teamstat[self.filters.teamStatsHomeAwayFilter.selectedKey]
                .numMatches +
              ' matcher';
          }
          teamstat.position = position++;
        });
        return teams;
      },
      selectMenu: function(event) {
        var selectedVal = $(event.currentTarget).val();
        this.filters[
          $(event.currentTarget).attr('id')
        ].selectedKey = selectedVal;
        _.each(
          this.filters[$(event.currentTarget).attr('id')].filterValues,
          function(filterValue) {
            filterValue.selected = false;
          }
        );
        this.filters[$(event.currentTarget).attr('id')].filterValues[
          selectedVal
        ].selected = true;

        if ($(event.currentTarget).attr('id') === 'playerStatsTeamFilter') {
          this.filters.playerStatsTypeFilter.filterValues = {};
          _.each(this.sortedTeamList, function(sortedTeam) {
            sortedTeam.selected = false;
            if (selectedVal === sortedTeam.id) {
              sortedTeam.selected = true;
            }
          });

          if (selectedVal !== 'all') {
            this.teamId = selectedVal;
            this.model.setCurrentTeam(this.teamId);
            return;
          }
        }

        if ($(event.currentTarget).attr('id') === 'underlyingLeaguesFilter') {
          this.resetFilters();
          this.filters.leagueTableFilter = {
            filterValues: {},
            selectedKey: '',
            showDropDown: false
          };
          this.showLoader();
          var leagueId = selectedVal.split('_')[1];
          this.model.setCurrentLeague(leagueId);
          return;
        }

        this.filters.playerStatsQuantity = this.PAGE_SIZE;
        this.filters.teamStatsQuantity = this.PAGE_SIZE;
        this.render({});
      },

      retrieveSportById: function(sportId) {
        return new svs.sport.themeLoader().retrieveSportById(sportId);
      },

      resetFilters: function() {
        if (!this.filters) {
          this.createFilters();
        } else {
          this.filters.playerStatsTeamFilter = {
            filterValues: {
              all: { name: 'Alla lag', selected: false, id: 'all' }
            },
            selectedKey: 'all',
            disableDropDown: true
          };
          this.filters.playerStatsTypeFilter.filterValues = {};
        }
        this.firstTime = true;
        this.sortedTeamList = [];
        this.teamId = null;
      },
      moreButton: function(event) {
        this.filters[$(event.currentTarget).attr('id')] += this.PAGE_SIZE;
        this.render({});
      },
      onDestroy: function() {
        this.stopListening();
        if (this.model) {
          this.model.off();
          this.model.stopListening();
          this.model.dispose();
          delete this.model;
        }

        if (this.leaguesModel) {
          this.leaguesModel.off();
          this.leaguesModel.stopListening();
          this.leaguesModel.dispose();
          this.leaguesModel = null;
          delete this.leaguesModel;
        }

        this.options.params.parent = null;
        this.options.params = null;
        this.options = null;

        this.sortedTeamList = [];
        this.resetFilters();

        this.remove();
        delete this.options;
        delete this.$el;
        delete this.el;
      }
    }
  );
})(Backbone, _, svs);

 })(window);